import { Button, Divider, Dropdown, Form, Modal, PageHeader, Space, Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import purchaseOrderItemService from '../../../services/purchase_order/purchase_order_item.service';
import { EllipsisOutlined } from '@ant-design/icons';
import OrderItemAdd from './order_items_add';
import { useDispatch, useSelector } from 'react-redux';
import { set_update_order } from '../../../actions/purchase_order.action';

const { confirm } = Modal;
const OrderItem = ({ order_id, edit, supplier_id }) => {
    const purchase_order_redux = useSelector(state => state.purchase_order);
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [state, setState] = useState({
        loading: false,
        order_items: [],
        edit_modal: false,
        refresh: 0,
        edit_modal_id: null,
        confirmLoading: false
    })

    const fetchOrderItems = async () => {
        setState(state => ({ ...state, loading: true }))
        const orderItemsResponse = await purchaseOrderItemService?.getOrderItems({
            order_id: order_id,
        });
        const order_items = orderItemsResponse?.order_items;
        setState(state => ({ ...state, order_items: order_items, loading: false }))
    }

    const addOrderItem = async () => {
        form.validateFields()
            .then(async (values) => {
                setState(state => ({ ...state, confirmLoading: true, }));

                const { itemId, quantity, unit_price, free } = form.getFieldsValue();

                let orderItemsResponse;
                if (state?.edit_modal_id) {
                    //update
                    orderItemsResponse = await purchaseOrderItemService.updateOrderItems(state?.edit_modal_id, {
                        order_id: order_id,
                        item_id: itemId,
                        unit_price: unit_price,
                        quantity: quantity,
                        free: free ?? 0
                    })
                } else {
                    //store a new order items
                    orderItemsResponse = await purchaseOrderItemService.createOrderItems({
                        order_id: order_id,
                        item_id: itemId,
                        unit_price: unit_price,
                        quantity: quantity,
                        free: free ?? 0
                    });
                }
                dispatch(set_update_order(true));

                setState(state => ({ ...state, refresh: (state?.refresh + 1), edit_modal: false, confirmLoading: false, }));
            })
            .catch(() => {
                setState(state => ({ ...state, confirmLoading: false, }));

            });

    }

    const openEditModal = ({ order_item_id = null, item_id, quantity, unit_price, free }) => {
        setState(state => ({ ...state, edit_modal: true, edit_modal_id: order_item_id }));
        form.setFieldsValue({ itemId: item_id, quantity: quantity, unit_price: unit_price, free: free });
    }

    const deleteConfirmationModal = async (order_item_id) => {
        confirm({
            title: 'Do you want to delete this order item?',
            onOk() {
                return new Promise((resolve, reject) => {
                    setTimeout(async () => {
                        await deleteOrderItem(order_item_id);
                        resolve();
                    }, 500);
                }).catch((err) => {

                })
            }
        })
    }

    const deleteOrderItem = async (order_item_id) => {
        const orderItemsResponse = await purchaseOrderItemService.deleteOrderItems(order_item_id, { order_id: order_id, });
        dispatch(set_update_order(true));
        setState(state => ({ ...state, refresh: (state?.refresh + 1) }));
    }

    const cancelAddItem = () => {
        form.resetFields();
        setState(state => ({ ...state, edit_modal: false, }));
    }

    useEffect(() => {
        fetchOrderItems();
    }, [state?.refresh, order_id])


    return (
        <>
            <div style={{ textAlign: 'left', padding: '12px 0' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Order Items</span>
                    </div>
                    {
                        edit &&
                        (
                            <>
                                <div style={{ marginLeft: 'auto' }}>
                                    <span onClick={() => openEditModal({})} className='mini-button mini-style-text'>
                                        Add Item
                                    </span>
                                </div>
                            </>
                        )
                    }

                </div>
            </div>
            <Divider style={{ marginTop: 12 }} />
            <Spin spinning={state?.loading}>
                <Table
                    pagination={false}
                    dataSource={state?.order_items}
                    className='hub-table'
                    footer={(text) => {
                        const total_price = text?.reduce((a, b) => a + (b.quantity * parseFloat(b.unit_price)), 0);
                        const quantity = text?.reduce((a, b) => a + (b.quantity), 0);
                        const free_quantity = text?.reduce((a, b) => a + (b.free), 0);
                        const total_quantity = quantity + free_quantity;
                        return (
                            <>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginLeft: 'auto', textAlign: 'end' }}>
                                        <div>
                                            <Space>
                                                <div>
                                                    <span>Total Quantity: </span>
                                                </div>
                                                <div>
                                                    <span>{total_quantity}</span>
                                                </div>
                                            </Space>
                                        </div>
                                        <div>
                                            <Space>
                                                <div>
                                                    <span>Total Price: </span>
                                                </div>
                                                <div>
                                                    <span>{`MYR${total_price?.toFixed(3)}`}</span>
                                                </div>
                                            </Space>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    }
                    columns={[{
                        title: 'Item Code',
                        dataIndex: 'item',
                        key: 'item_code',
                        render: (text, row, index) => {
                            return (
                                <>
                                    <div>
                                        <span>{text?.item_code}</span>
                                    </div>
                                </>
                            )
                        }
                    }, {
                        title: 'Item Name',
                        dataIndex: 'item',
                        key: 'name',
                        render: (text, row, index) => {
                            return (
                                <>
                                    <div>
                                        <span>{text?.name}</span>
                                    </div>
                                </>
                            )
                        }
                    }, {
                        title: 'Quantity',
                        dataIndex: 'quantity',
                        key: 'quantity',

                    }, {
                        title: 'Free',
                        dataIndex: 'free',
                        key: 'free',
                    }, {
                        title: 'Unit Price (RM)',
                        dataIndex: 'unit_price',
                        key: 'unit_price',
                        render: (text, row, index) => {
                            return (
                                <>
                                    <div>
                                        <span>{((row?.quantity * row?.unit_price) / (row?.quantity + row?.free)).toFixed(3)}</span>
                                    </div>
                                </>
                            )
                        }
                    }, {
                        title: 'Total Price (RM)',
                        dataIndex: 'unit_price',
                        key: 'unit_price',
                        render: (text, row, index) => {
                            return (
                                <>
                                    <div>
                                        <span>{(row?.quantity * row?.unit_price).toFixed(3)}</span>
                                    </div>
                                </>
                            )
                        }
                    }, {
                        ...edit && ({
                            title: 'Action',
                            key: 'action',
                            dataIndex: 'order_item_id',
                            width: '10%',
                            render: (text, row, index) => {
                                return (
                                    <>
                                        <div>
                                            <Dropdown
                                                placement='bottomRight'
                                                overlayStyle={{ borderRadius: 12, minWidth: 200 }}
                                                menu={{
                                                    items: [{
                                                        key: '1',
                                                        type: 'group',
                                                        label: "Action",
                                                        children: [{
                                                            key: '1-1',
                                                            label: "Edit",
                                                            onClick: async () => {
                                                                openEditModal({ order_item_id: text, item_id: row?.item_id, quantity: row?.quantity, unit_price: row?.unit_price, free: row?.free })
                                                            }
                                                        }, {
                                                            key: '1-2',
                                                            label: "Delete",
                                                            onClick: async () => {
                                                                deleteConfirmationModal(text);
                                                            }
                                                        },]
                                                    },]
                                                }}
                                            >
                                                <Button size='small' icon={<EllipsisOutlined />} style={{ borderRadius: 6 }} />
                                            </Dropdown>
                                        </div>
                                    </>
                                )
                            }
                        })
                    }]}
                />
            </Spin>


            <Modal
                open={state?.edit_modal}
                transitionName="ant-fade"
                maskTransitionName="ant-fade"
                title={<><span>{state?.edit_modal_id ? 'Update Order Item' : 'Add Order Item'}</span></>}
                width={500}
                closable={false}
                className="custom-modal"
                onOk={() => form.submit()}
                onCancel={cancelAddItem}
                confirmLoading={state?.confirmLoading}
            >
                <Form
                    id='order_item_form'
                    onFinish={addOrderItem}
                    form={form}
                    layout='vertical'
                >
                    <OrderItemAdd form={form} supplier_id={supplier_id} edit_modal={state?.edit_modal_id} />
                </Form>
            </Modal>
        </>
    );
}

export default OrderItem;